import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';

import ModernDialog from '@components/dialogs/ModernDialog';
import { HelpIcon } from '@componentsV2/icons/icons';
import Colors from 'styles/colors';

const HelpDialog = ({ title, content, getButtonView, iconColor, wrapperClassName }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getButton = () => {
    if (!getButtonView) {
      return (
        <IconButton
          onClick={handleOpen}
          className="ml-auto p-2 rounded-full lg:rounded-xl"
          style={{ marginRight: '0.2rem' }}
        >
          <div className="hidden lg:block text-white text-lg font-medium mr-2">Help</div>
          <HelpIcon width="24" height="24" fill={iconColor} />
        </IconButton>
      );
    }
    return getButtonView({ onClick: handleOpen });
  };

  return (
    <div className={wrapperClassName}>
      {getButton()}
      <ModernDialog
        open={open}
        onCancel={handleClose}
        onConfirm={handleClose}
        title={title}
        maxWidth="md"
        fullWidth
        hideCancelButton
        confirmText="Ok"
        content={content}
        fullScreenOnMobile
      />
    </div>
  );
};

HelpDialog.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  getButtonView: PropTypes.func,
  iconColor: PropTypes.string,
  wrapperClassName: PropTypes.string
};

HelpDialog.defaultProps = {
  getButtonView: null,
  iconColor: Colors.white.default,
  wrapperClassName: 'ml-auto'
};

export default HelpDialog;
